import { getPageHeader, PageContainer, PageHeader, PageHeaderLeading } from '@yeshuman/sdk'
import { Headset } from 'lucide-react'
import { CallOperatorDashboardSections } from './components/call-operator-dashboard-sections'

export function CallOperatorDashboard() {
  return (
    <PageContainer>
      <PageHeader
        leading={<PageHeaderLeading />}
        {...getPageHeader(
          '/calls',
          'Dashboard',
          'Snapshot of calls, outcomes, and evaluations. Use the live board for real-time monitoring.'
        )}
        icon={<Headset className="h-5 w-5" />}
      />

      <CallOperatorDashboardSections />
    </PageContainer>
  )
}
